import { render, staticRenderFns } from "./Tournament.vue?vue&type=template&id=0f480cac&"
import script from "./Tournament.vue?vue&type=script&lang=ts&"
export * from "./Tournament.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports